import backofficeService from '@/api/backoffice.js'

export default {
  /**
   * Get list of termComments
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to termComments
   */
  getAll(params) {
    return backofficeService.Api().get('termComment', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Get specific termComment
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to termComment
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`termComment/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
   * Create a termComment. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('termComment', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific termComment
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`termComment/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete termComment
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`termComment/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

}